import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import config from 'devextreme/core/config';

import faMessages from 'devextreme/localization/messages/fa.json';
import { locale, loadMessages } from 'devextreme/localization';
import { LoaderService } from './core/services/loader.service';
import { TitleService } from './core/services/title.service';
import { UpdateService } from './core/services/update.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private licenseObserver?: MutationObserver;

  constructor(
    private authService: AuthService,
    public loader: LoaderService,
    private titleService: TitleService,
    private updateService: UpdateService,
    private translate: TranslateService
  ) {
    config({ rtlEnabled: true });

    loadMessages(faMessages);
    locale('fa');
    this.translate.addLangs(['fa']);
    this.translate.setDefaultLang('fa');
    this.translate.use('fa');
  }

  ngOnInit(): void {
    this.authService.autoLogin();
    this.titleService.init();
  }

  ngAfterViewInit(): void {
    // Remove license element immediately
    this.removeLicenseElement();

    // Set up MutationObserver to catch license element if added dynamically
    this.licenseObserver = new MutationObserver(() => {
      this.removeLicenseElement();
    });

    // Observe changes to the document body
    this.licenseObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  ngOnDestroy(): void {
    if (this.licenseObserver) {
      this.licenseObserver.disconnect();
    }
  }

  private removeLicenseElement(): void {
    const licenseElement = document.querySelector('dx-license');
    if (licenseElement) {
      licenseElement.remove();
    }
  }
}
